import Navbar from "./components/Header";
import styled, { css } from "styled-components";
import Intro from "./components/Intro";
import Feature from "./components/Feature";
import Offres from "./components/Offres";
import Price from "./components/Price";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Shape = css`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`;

const Container = styled.div`
  height: 100vh;
  position: relative;
  overflow: hidden;
`;

const IntroShape = styled.div`
  ${Shape}
  clip-path: polygon(75% 0, 100% 0%, 100% 100%, 55% 100%);
  background-color: crimson;
`;

const FeatureShape = styled.div`
  ${Shape}
  clip-path: polygon(0 0, 55% 0%, 33% 100%, 0 100%);
  background-color: pink;
`;

const OffresShape = styled.div`
  ${Shape}
  clip-path: polygon(0 0, 33% 0%, 33% 100%, 0 100%);
  background-color: #f88497;
`;
const PriceShape = styled.div`
  ${Shape}
  clip-path: polygon(0 0, 33% 0%, 100% 100%, 55% 100%);
  background-color: pink;
`;

const ContactShape = styled.div`
  ${Shape}
  clip-path: polygon(55% 0, 100% 0%, 100% 90%, 55% 90%);
  background-color: crimson;
  z-index: 1;
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

const App = () => {
  return (
    <>
      <Container>
        <Navbar />
        <Intro />
        <IntroShape />
      </Container>

      <Container>
        <Feature />
        <FeatureShape />
      </Container>

      <Container>
        <Offres />
        <OffresShape />
      </Container>

      <Container>
        <Price />
        <PriceShape />
      </Container>

      <Container>
        <Contact />
        <ContactShape />
        <Footer />
      </Container>
    </>
  );
};

export default App;
